import { useCallback, useMemo, useState } from "react";

export const useLayout = ({ trackWidth = true, trackHeight = true } = {}) => {
    const [layout, setLayout] = useState({ width: null, height: null });

    const onLayout = useCallback((e) => {
        let { width, height } = e.nativeEvent.layout;

        // RN Web / Subpixel: stabilisieren
        width = Math.round(width);
        height = Math.round(height);

        setLayout((prev) => {
            const nextWidth = trackWidth ? width : prev.width;
            const nextHeight = trackHeight ? height : prev.height;

            if (prev.width === nextWidth && prev.height === nextHeight) return prev;
            return { width: nextWidth, height: nextHeight };
        });
    },[trackWidth, trackHeight]);

    return useMemo(() => ({
        onLayout,
        setLayout,
        layout,
        width: layout.width,
        height: layout.height,
    }), [onLayout, layout]);
};


export const useLayoutHeight = () => {
  const { onLayout, height } = useLayout({ trackWidth: false });
  return { onLayout, height };
};

export const useLayoutWidth = () => {
  const { onLayout, width } = useLayout({ trackHeight: false });
  return { onLayout, width };
};